import { j as s } from "./jsx-runtime-C5mzlN2N.js";
import { CheckIcon as u, CopyIcon as b } from "lucide-react";
import { useState as x, useCallback as h, useRef as f } from "react";
import { c as i } from "./cn-dYga0KKN.js";
const v = (e = 2e3) => {
  const [o, t] = x(!1), r = h(
    (c) => {
      navigator.clipboard.writeText(c), t(!0), setTimeout(() => t(!1), e);
    },
    [e]
  );
  return [o, r];
}, y = {
  typescript: /(tsx?|typescript)/,
  javascript: /(jsx?|javascript)/,
  markdown: /(md|markdown)/,
  mdx: /(mdx)/,
  json: /(json)/,
  yaml: /(yaml)/,
  toml: /(toml)/,
  bash: /(shell|bash|sh|zsh)/,
  python: /(py|python)/,
  dotnet: /(cs|csharp|vb)/,
  rust: /(rs|rust)/,
  ruby: /(rb|ruby)/,
  php: /php/,
  html: /html?/,
  css: /css/
}, C = (e) => {
  if (!e) return;
  const o = Object.entries(y).find(
    ([t, r]) => r.test(e)
  );
  return o ? `https://cdn.simpleicons.org/${o[0]}/000/fff?viewbox=auto` : void 0;
}, N = ({
  children: e,
  title: o = "Code",
  language: t,
  showCopy: r = "hover",
  showLanguageIndicator: c,
  showLineNumbers: d,
  ...p
}) => {
  const [n, m] = v(), a = f(null);
  if (!e) return null;
  const l = c ? C(t) : void 0;
  return /* @__PURE__ */ s.jsxs(
    "div",
    {
      className: i(
        "border code-block-wrapper relative group bg-muted/50 rounded-md overflow-hidden",
        d && "line-numbers"
      ),
      children: [
        /* @__PURE__ */ s.jsxs("div", { className: "border-b flex items-center h-10 font-sans bg-black/2", children: [
          /* @__PURE__ */ s.jsxs("div", { className: "flex items-center gap-2 flex-1 text-sm w-full px-3", children: [
            l && /* @__PURE__ */ s.jsx("img", { src: l, className: "h-3 max-w-4" }),
            o
          ] }),
          " ",
          r !== "never" && /* @__PURE__ */ s.jsx(
            "button",
            {
              type: "button",
              "aria-label": "Copy code",
              title: "Copy code",
              className: i(
                "transition px-2 py-2 mx-1 rounded-sm",
                !n && "hover:bg-accent hover:brightness-95"
              ),
              disabled: n,
              onClick: () => {
                a.current?.textContent && m(a.current.textContent);
              },
              children: n ? /* @__PURE__ */ s.jsx(u, { className: "text-emerald-600", size: 14 }) : /* @__PURE__ */ s.jsx(b, { size: 14 })
            }
          )
        ] }),
        /* @__PURE__ */ s.jsx(
          "div",
          {
            className: i(
              "code-block text-sm not-prose scrollbar overflow-x-auto scrollbar [&>code]:p-3 [&>code]:py-2",
              p.className
            ),
            ref: a,
            children: e
          }
        )
      ]
    }
  );
};
export {
  N as C,
  v as u
};
//# sourceMappingURL=CodeBlock-NFCmSWOK.js.map
